/*
document.addEventListener('_changeVariant', function(event) {
  //console.log('Variant change')
});
*/

/*
document.addEventListener('cartItems', function(event) {
  //console.log('Cart has been updated')
});
*/

(function() {
  function initCard(container) {
    if (container.dataset.glideInit) return;
    container.dataset.glideInit = '1';
    var attr = container.getAttribute('data-variant-imgs');
    if (!attr) return;
    var srcs;
    try { srcs = JSON.parse(attr).filter(Boolean); } catch(e) { return; }
    if (srcs.length < 2) return;

    var target = container.querySelector('.relative.lazycontainer') || container;
    var glide = document.createElement('div');
    glide.className = 'ribble-auto-glide';

    srcs.forEach(function(src, i) {
      var img = document.createElement('img');
      img.src = src;
      img.style.opacity = i === 0 ? '1' : '0';
      glide.appendChild(img);
    });

    target.style.position = 'relative';
    target.appendChild(glide);

    var slides = glide.querySelectorAll('img');
    var idx = 0;
    var timer = null;

    function tick() {
      slides[idx].style.opacity = '0';
      idx = (idx + 1) % slides.length;
      slides[idx].style.opacity = '1';
    }

    function start() { if (!timer) timer = setInterval(tick, 2500); }
    function stop() { clearInterval(timer); timer = null; }

    container.addEventListener('mouseenter', stop);
    container.addEventListener('mouseleave', start);
    slides[0].complete ? start() : slides[0].addEventListener('load', start, {once:true});
  }

  function initAll() {
    if (window.location.pathname.indexOf('/collections/') === -1 && window.location.pathname.indexOf('/products/') === -1) return;
    document.querySelectorAll('.product-thumb[data-variant-imgs]').forEach(initCard);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initAll)
    : initAll();

  new MutationObserver(function(mutations) {
    if (window.location.pathname.indexOf('/collections/') === -1 && window.location.pathname.indexOf('/products/') === -1) return;
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.product-thumb[data-variant-imgs]')) initCard(node);
        if (node.querySelectorAll) node.querySelectorAll('.product-thumb[data-variant-imgs]').forEach(initCard);
      });
    });
  }).observe(document.body, {childList:true, subtree:true});

})();


// RIBBLE COLLECTION GLIDE — v3 (CSS-first flash fix)
(function () {
  function initSlideshows() {
    if (
      window.location.pathname.indexOf('/collections/') === -1 &&
      window.location.pathname.indexOf('/products/') === -1
    ) return;

    document.querySelectorAll('.product-thumb').forEach(function (thumb) {
      if (thumb.dataset.glideInit) return;
      thumb.dataset.glideInit = '1';

      var link = thumb.querySelector('a');
      if (!link) return;
      var match = (link.getAttribute('href') || '').match(/\/products\/([^?#]+)/);
      if (!match) return;
      var handle = match[1];

      var imageWrap =
        thumb.querySelector('.relative.lazycontainer') ||
        thumb.querySelector('.product-image') ||
        thumb;

      // Mark imageWrap so CSS hides the static img immediately
      imageWrap.classList.add('ribble-glide-target');

      var staticImg = imageWrap.querySelector('img');

      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var seen = new Set();
          var imgs = [];

          product.variants.forEach(function (v) {
            if (
              v.featured_image &&
              v.featured_image.src &&
              !seen.has(v.featured_image.src)
            ) {
              seen.add(v.featured_image.src);
              imgs.push(v.featured_image.src);
            }
          });

          // Not enough images — restore static img and bail
          if (imgs.length < 2) {
            if (staticImg) staticImg.classList.add('ribble-static-restored');
            return;
          }

          if (staticImg) staticImg.style.display = 'none';

          var slideshowHtml =
            '<div class="ribble-slideshow ribble-slideshow--ready">' +
            imgs.map(function (src, i) {
              return (
                '<img src="' + src + '" class="ribble-slide-img' +
                (i === 0 ? ' active' : '') +
                '" alt="" loading="' + (i === 0 ? 'eager' : 'lazy') + '"' +
                (i === 0 ? ' fetchpriority="high"' : '') +
                '>'
              );
            }).join('') +
            '<div class="ribble-slide-dots">' +
            imgs.map(function (_, i) {
              return (
                '<span class="ribble-slide-dot' +
                (i === 0 ? ' active' : '') +
                '"></span>'
              );
            }).join('') +
            '</div></div>';

          imageWrap.insertAdjacentHTML('beforeend', slideshowHtml);

          var show = imageWrap.querySelector('.ribble-slideshow');
          var slideImgs = show.querySelectorAll('.ribble-slide-img');
          var dots = show.querySelectorAll('.ribble-slide-dot');
          var current = 0;
          var timer = setInterval(advance, 2500);

          function advance() {
            slideImgs[current].classList.remove('active');
            dots[current].classList.remove('active');
            current = (current + 1) % slideImgs.length;
            slideImgs[current].classList.add('active');
            dots[current].classList.add('active');
          }

          thumb.addEventListener('mouseenter', function () { clearInterval(timer); });
          thumb.addEventListener('mouseleave', function () { timer = setInterval(advance, 2500); });
        })
        .catch(function () {
          // Fetch failed — restore static image
          if (staticImg) staticImg.classList.add('ribble-static-restored');
        });
    });
  }

  // No setTimeout delay needed — CSS handles the hide, JS just enriches
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlideshows);
  } else {
    initSlideshows();
  }
})();



// RIBBLE PDP — Variant colour → jump to matching slide
(function () {
  function initPDPVariantJump() {
    var gliderEl = document.querySelector('.glider.slideshow');
    if (!gliderEl || !gliderEl._glider) { setTimeout(initPDPVariantJump, 200); return; }
    var glider = gliderEl._glider;

    document.querySelectorAll('input.img-align.keyed').forEach(function(input, i) {
      input.addEventListener('change', function() {
        glider.scrollItem(i);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(initPDPVariantJump, 600); });
  } else {
    setTimeout(initPDPVariantJump, 600);
  }
})();


/* -------------------------------------------------------
   RIBBLE — PE Top thumbnail click → swap main image
------------------------------------------------------- */
(function () {
  function initPETopThumbs() {
    var mainImg = document.querySelector('.product__media-item img');
    if (!mainImg) return;

    var handle = window.Shopify && window.Shopify.designMode
      ? null
      : document.querySelector('[data-product-handle]')
          ? document.querySelector('[data-product-handle]').getAttribute('data-product-handle')
          : window.location.pathname.split('/products/')[1];

    var thumbDivs = document.querySelectorAll('[class*="three mobile thumb-image-"]');
    if (!thumbDivs.length) return;

    thumbDivs.forEach(function (div) {
      var thumbLink = div.querySelector('a.product-thumb-main');
      var thumbImg  = div.querySelector('img');
      if (!thumbLink || !thumbImg) return;

      var href = thumbLink.getAttribute('href') || '';
      if (handle && !href.includes(handle)) return;

      thumbLink.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var fullSrc = thumbImg.getAttribute('data-src') || thumbImg.src;
        if (fullSrc) mainImg.src = fullSrc;
        if (thumbImg.srcset) mainImg.srcset = thumbImg.srcset;

        thumbDivs.forEach(function (d) { d.classList.remove('active'); });
        div.classList.add('active');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPETopThumbs);
  } else {
    initPETopThumbs();
  }
})();

// RIBBLE PDP — Variant colour → jump to matching slide
(function () {
  // Only run on PDP pages
  if (!document.querySelector('main#content.product-page')) return;

  function initPDPVariantJump() {
    var gliderEl = document.querySelector('.glider.slideshow');
    if (!gliderEl || !gliderEl._glider) { setTimeout(initPDPVariantJump, 200); return; }
    var glider = gliderEl._glider;

    document.addEventListener('change', function(e) {
      if (!e.target || !e.target.classList.contains('selector-option')) return;
      var inputs = document.querySelectorAll('input.selector-option');
      var idx = Array.prototype.indexOf.call(inputs, e.target);
      if (idx === -1) return;
      glider.scrollItem(idx);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(initPDPVariantJump, 600); });
  } else {
    setTimeout(initPDPVariantJump, 600);
  }
})();
